import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { FabbricatiComponent } from 'src/app/anagrafiche/fabbricati/fabbricati.component';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => FabbricatoPickerComponent) },
  ],
  selector: 'fabbricato-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class FabbricatoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(FabbricatiComponent, { data: { selectionMode: true } }).afterClosed();
  };

  getRoute = (id) => `/fabbricati/${id}`;

}
